import {DeleteOutlined, EditOutlined, HomeOutlined, PlusOutlined} from '@ant-design/icons';
import {Breadcrumb, Button, Popconfirm, Table, Tag, Tooltip} from 'antd';
import dayjs from 'dayjs';
import {useState} from 'react';
import toast from 'react-hot-toast';
import {useSelector} from 'react-redux';

import {RQDeleteOfferAPI, RqGetOffers} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

import {OffersModal} from './OffersModal';

const Offers = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [updateRecord, setUpdateRecord] = useState(null);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const {data: offersData, refetch} = RqGetOffers(token);

  const handleEdit = record => {
    setUpdateRecord(record);
    setIsModalVisible(true);
  };

  const {mutate: deleteOffer} = RQDeleteOfferAPI({
    onSuccess: () => {
      toast.success('Offer deleted successfully');
      refetch();
    },
    onError: error => {
      toast.error(error?.message);
    },
  });

  const handleDeleteOffer = id => {
    deleteOffer({token, id});
  };

  const columns = [
    {title: 'Sr. No.', dataIndex: 'srno', key: 'srno', width: 50},
    {title: 'Name', dataIndex: 'name', key: 'name', width: 150},
    {title: 'Value', dataIndex: 'value', key: 'value', width: 80, render: value => `${value}%`},
    {
      title: 'Valid From',
      dataIndex: 'validFrom',
      key: 'validFrom',
      width: 150,
    },
    {
      title: 'Valid Until',
      dataIndex: 'validUntil',
      key: 'validUntil',
      width: 150,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: status => {
        let color = 'default';
        if (status === 'ACTIVE') { color = 'green'; }
        else if (status === 'EXPIRED') { color = 'red'; }
        else if (status === 'INACTIVE') { color = 'orange'; }
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: 'Action',
      key: 'action',
      width: 80,
      render: (_, record) => (
        <div className={'flex gap-2'}>
          <Tooltip title={'Edit Offer'}>
            <Button
              type={'link'}
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Popconfirm
            title={'Delete This Offer ?'}
            onConfirm={() => handleDeleteOffer(record.id)}
            okText={'Yes'}
            cancelText={'No'}
            width={50}
            okButtonProps={{
              className: '!bg-primary-800 text-white hover:!bg-primary-900',
            }}
          >
            <DeleteOutlined className={'text-error cursor-pointer text-[#FF0000]'} />
          </Popconfirm>
        </div>

      ),
    },
  ];

  const formattedData = offersData?.map((item, idx) => ({
    key: item.id,
    id: item.id,
    srno: idx + 1,
    name: item?.name,
    value: item?.value,
    minOrderAmount: item?.minOrderAmount,
    maxDiscount: item?.maxDiscount,
    description: item?.description,
    applicableProductIds: item?.applicableProductIds,
    validFrom: item?.validFrom ? dayjs(item.validFrom).format('YYYY-MM-DD') : '-',
    validUntil: item?.validUntil ? dayjs(item.validUntil).format('YYYY-MM-DD') : '-',
    status: item?.status,
  }));

  return (
    <div>
      <Breadcrumb
        className={'lg:block hidden'}
        items={[
          {href: '/', title: <HomeOutlined />},
          {title: <span>Offers</span>},
        ]}
      />

      <div className={'flex justify-between items-center mt-3'}>
        <h1 className={'font-bold text-lg text-primary-800'}>Offers List</h1>

        <Button type={'primary'} onClick={() => setIsModalVisible(true)}>
          <PlusOutlined /> Add New Offer
        </Button>
      </div>

      <div className={'mt-4'}>
        <Table
          // loading={isLoading}
          columns={columns}
          dataSource={formattedData}
          scroll={{x: 'max-content'}}
          pagination={{
            pageSizeOptions: ['10', '20', '50'],
            showSizeChanger: true,
          }}
        />
      </div>

      <OffersModal
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setUpdateRecord(null);
        }}
        refetch={refetch}
        updateRecord={updateRecord}
      />
    </div>
  );
};

export default Offers;
